/**
 * Formats input values for creating or updating candidate education records.
 *
 * @param {Object} values - The new input values.
 * @param {Object} initialValues - The initial input values for comparison (optional).
 * @returns {Object} - The formatted education information.
 *
 * @example
 * const values = {
 *   startYear: '2021-09-01',
 *   graduationYear: '2025-06-30',
 *   university: { label: 'Example University', value: '12345' },
 *   degree: { label: 'Bachelor of Science' },
 * };
 *
 * const initialValues = {
 *   university: {
 *     label: 'Initial University',
 *   }
 * };
 *
 * const formattedInput = formatEducationInput(values, initialValues);
 * // Result:
 * // {
 * //   startYear: '2021-09-01',
 * //   graduationYear: '2025-06-30',
 * //   university: 'Example University',
 * //   university_entity_id: '12345',
 * //   degree: 'Bachelor of Science',
 * // }
 */
export const formatEducationInput = (values, initialValues) => {
  // Ensure that we set the `university_entity_id` to null if the user changed it
  // from a dropdown-selected value to free text
  const hasChangedUni = values.university.label !== initialValues?.university?.label

  const newUniEntityId = values.university.value || null

  return {
    ...values,
    degree: values.degree.label,
    university: values.university.label,
    university_entity_id: hasChangedUni ? newUniEntityId : undefined,
  }
}
